import './assets/styles.css'
import CarouselSevices, { servicesTravel } from '../share/components/CarouselServices/CarouselSevices'
import Find from '../share/components/Find/Find'
import { useRef } from 'react'
import * as locales from 'react-date-range/dist/locale';
import Paginado from '../../../Routes/Home/Paginado'
import compra from "../../../Components/TravelLanding/assets/img/travel04.jpg"
import download from "../../../Components/TravelLanding/assets/img/travel05.jpg"
import ws from '../../assets/images/WsTwo.png'
import palma from '../../assets/images/packages.png'
import { DateRange, Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Airplane, Car, HomeWifi, Location, Calendar1, SearchNormal, } from 'iconsax-react'
import Paquetes from '../../viewModels/packages/Paquetes'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { Grid } from '@mui/material'
import CardGlobal from '../share/components/cardGlobal';



const MotionConstraints = styled(motion.div)`
    overflow-x: hidden;
  `;

const MotionBox = styled(motion.div)`
    width: 400vw;
  `


const Packages = () => {

    const constraintsRef = useRef(null)

    const {
        paquetes,
        nextHandler,
        prevHandler,
        selectTypeResercation,
        background,
        calendar,
        setcalendar,
        calendarTwo,
        setCalendarTwo,
        typeT,
        setTypeT,
        services,
        topic,
        currentPage,
        mostrarNext,
        dated,
        setDated,
        date,
        setDate,
        localeOptions,
        locale,
        setLocale,
        cityDestiny,
        cityOrigin,
        setCityDestiny,
        setCityOrigin,
        originCityRef,
        destinyCityRef,
        roundTripPackages,
        goinRef
    } = Paquetes()


    return (
        <div>

            <Find></Find>

            <CarouselSevices current={servicesTravel[5].title} />
            <section className='contain-buscador-packages'>
                <div className='layout-one-t'>
                    <div className='reserva-p' >
                        <div className={background === 1 ? 'select' : 'unselect'} onClick={() => selectTypeResercation(1)}>
                            <p><Airplane size="30" /> Reserva tu vuelo + <HomeWifi size="30" />Hotel</p>
                        </div>

                        <div className={background === 1 ? 'unselect' : 'select'} onClick={() => selectTypeResercation(2)}>
                            <p><Airplane size="30" /> Reserva tu vuelo + <Car size="30" />  Auto</p>
                        </div>
                    </div>
                    <div className="campo-radio">
                        <div>
                            <input type="radio" value={0} onChange={(e) => {
                                setTypeT(e.target.value)
                                date[0].endDate = null

                            }} name='tipo' required />
                            <label htmlFor="">Ida</label>
                        </div>
                        <div>
                            <input type="radio" value={1} onChange={(e) => {
                                setTypeT(e.target.value)
                                setDated(null)
                            }} name='tipo' required />
                            <label htmlFor="">Ida y Vuelta</label>
                        </div>
                    </div>
                    <div className='campo-double'>
                        <div className='origin-city-parent'>
                            <div className='origin-city'  onClick={() => {
                                setCityOrigin(!cityOrigin)
                            }}>
                                <p className='title-o'>Origen</p>
                                <p className='city-select-p'>Elige una ciudad <Location size="30" color="#004274" /></p>
                            </div>
                            {
                                cityOrigin === true ?

                                    <div className='dropdown-cityO-packages' ref={originCityRef}>
                                        <input type="text" placeholder='Ciudad Origen' />
                                    </div>

                                    :

                                    ''
                            }
                        </div>
                        <div className='destiny-city-parent'>
                            <div className='destiny-city'  onClick={() => {
                                setCityDestiny(!cityDestiny)
                            }}>
                                <p className='title-o'>Destino</p>
                                <p className='city-select-p'>Elige una ciudad <Location size="30" color="#004274" /></p>
                            </div>
                            {
                                cityDestiny === true ?

                                    <div className='dropdown-cityD-packages' ref={destinyCityRef} >
                                        <input type="text" placeholder='Ciudad Destino' />
                                    </div>

                                    :

                                    ''
                            }
                        </div>

                    </div>
                    <div className="campo-double" >
                        <div className='bbb'>
                            <div className={typeT == 1 ? "input-ca disabled" : "input-ca"} aria-disabled={typeT == 1 ? true : false} onClick={() => setcalendar(!calendar)}>
                                <p style={{ width: "100%", fontSize: "12px" }}>Ida</p>
                                <p className='date-p'>{dated !== null ? dated.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }) : "dd/mm/aaaa"}</p> <span><Calendar1 size="20" color="#004274" /></span>
                            </div>
                            <div className='calendar-t-l' ref={goinRef}>
                                {
                                    calendar === true &&
                                    <div className='shadow' style={{ display: 'flex', flexFlow: 'column nowrap', background: "white", borderRadius: "15px", }}>
                                        <select
                                            style={{ margin: '20px auto' }}
                                            onChange={e => setLocale(e.target.value)}
                                            value={locale}
                                        >
                                            {localeOptions.map((option, i) => (
                                                <option value={option.value} key={i}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                        <Calendar onChange={item => {
                                            setDated(item)
                                            setcalendar(!calendar)
                                        }}
                                            locale={locales[locale]} date={dated} />
                                    </div>
                                }

                            </div>

                        </div>
                        <div className='bbb'>
                            <div className={typeT == 0 ? "input-ca disabled" : "input-ca"}  aria-disabled={typeT == 0 ? true : false} onClick={() => setCalendarTwo(!calendarTwo)}>
                                <p style={{ width: "100%", fontSize: "12px" }}>Ida y vuelta</p>
                                <p className='date-p'>{date[0].endDate !== null ? date[0].startDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }) : "dd/mm/aaaa"}</p> <span>{date[0].endDate !== null ? date[0].endDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }) : ""}</span> <span><Calendar1 size="20" color="#004274" /></span>
                            </div>
                            <div className='calendar-t-r' ref={roundTripPackages} >
                                {
                                    calendarTwo === true &&
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={item => {
                                            setDate([item.selection])

                                        }}
                                        moveRangeOnFirstSelection={true}
                                        ranges={date}
                                    />
                                }

                            </div>

                        </div>
                    </div>

                    <div className='btn-search-p'>
                        <button>
                            <SearchNormal size="30" />
                        </button>
                    </div>

                </div>
                <div className='layout-two-t'>
                    <img className='up-img-p' src={palma} alt="" />
                </div>
            </section>
            <section className='contain-packages-all'>
                <div className='layout-packages'>
                    {
                        topic.map((item) => {
                            return (
                                <CardGlobal key={item.id} data={item} />
                            )
                        })
                    }
                </div>


                <div className='contain-carousel-p'>

                    <MotionConstraints className='slider_container' ref={constraintsRef}>
                        <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                            {
                                paquetes.map((item) => {
                                    return (
                                        <motion.div className='div_homeTurism' key={item.id}>
                                            <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                <CardGlobal key={item.id} data={item} />
                                            </Grid>
                                        </motion.div>
                                    )
                                })
                            }

                        </MotionBox>
                    </MotionConstraints>
                </div>
                <div className='contain-paginado'>

                    <Paginado

                        nextHandler={nextHandler}
                        prevHandler={prevHandler}
                        currentPage={currentPage}
                        mostrarNext={mostrarNext}
                        totalItems={services.length}
                    >

                    </Paginado>
                </div>
            </section>
            <section className='contain-contact-t'>
                <div>
                    <img className='img-ws-car' src={ws} alt="" />
                </div>
                <div className='text-contact-t'>
                    <h3>
                        ¿Tienes dudas? ¡Escribenos!
                    </h3>
                    <p>
                        Habla con un asesor vía whatsapp, cuentanos a que lugares quieres ir, que dudas tienes, que servicios necesitas? Estamos para que viajes con todas las comodidades
                    </p>
                </div>
            </section>
        </div>
    )
}

export default Packages